import { WarehouseTransfersStoreModule } from '@/shared';

export default WarehouseTransfersStoreModule;